export function pageHasMainSearchBlock()
{
	return $(document).find('.block.soegning[data-is-main-search=1]').length !== 0;
}
